module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d04305129eadebdbd60bbbcefd876177.png";